import Vue from "vue";
import VueX from "vuex";

import root from "./modules/root";
import eps from "./modules/eps";
import environment from "./modules/environment";
import affiliate from "./modules/affiliate";
import formDocuments from "./modules/formDocuments";
import drugstore from "./modules/drugstore";
import user from "./modules/user";
import appointments from "./modules/appointments";
import processing from "./modules/dataProcessing";

Vue.use(VueX);

export default new VueX.Store({
  modules: {
    root,
    eps,
    environment,
    affiliate,
    formDocuments,
    user,
    appointments,
    drugstore,
    processing,
  },
});
